var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('defs',[_c('path',{attrs:{"d":"M9 16h6v-6h4l-7-7-7 7h4v6zm-4 2h14v2H5v-2z","id":"file_upload_svg__a"}})]),_c('use',{attrs:{"fill":"#DC333E","fill-rule":"nonzero","xlink:href":"#file_upload_svg__a"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }